import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const GET_TARGET_VALUE_LOOKUP = "GET_TARGET_VALUE_LOOKUP";

export const service = async (data) => {
  const options: object = {
    url: `/api/lookup/GetCodeLookup/`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };

  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_TARGET_VALUE_LOOKUP, service, mock);
